import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ppFilter'
})
export class PpFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      return item.word.toLowerCase().includes(searchText) || item.normalizedWord.toLowerCase().includes(searchText);
    });
  }

}
